import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { z } from 'zod';
import { useForm } from 'react-hook-form';
import { IoIosCloseCircle } from "react-icons/io";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMyContext } from '../../../context/MyContext';
import { FaWarehouse } from "react-icons/fa6";
import '../../css/custom-scrollbar.css';
import { Base_Url, editwarehouse, getpincode } from '../../../config/config';
import { toast } from 'react-toastify';
import axios from 'axios';
import {
  FaIdCard,
  FaAddressCard,
  FaMapMarkerAlt,
  FaUndo,
  FaTimes,
  FaEdit,
  FaSave,
} from 'react-icons/fa';


const schema = z.object({
  // orderId: z.string()
  //   .min(1, "Order ID is required")
  //   .regex(/^\d+$/, "Order ID must be numeric"),
  Name: z.string()
    .min(1, "Name is required")
    .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabetic characters"),

  email: z.string()
    .email("Invalid email address"),
  phone: z.string()
    .length(10, "Phone number must be exactly 10 digits")
    .regex(/^\d+$/, "Phone number must be numeric"),
  contact_person: z.string()
    .min(1, "contact_person is required")
    .regex(/^[a-zA-Z\s]+$/, "contact_person must only contain alphabetic characters"),
  // status: z.string().min(1, "Status is required"),
  date: z.string().min(1, "Add Date is required"),
  // address: z.string().min(1, "Address is required"),
   address: z
  .string()
  .min(1, "Address is required")
  .regex(/^[^#\\%&;]*$/, "Address contains invalid characters (# \\ % & ; not allowed)"),
  pincode: z.string()
    .length(6, "Pincode must be exactly 6 characters")
    .regex(/^\d+$/, "Pincode must be numeric"),
  city: z.string()
    .min(1, "City is required")
    .regex(/^[A-Za-z\s]+$/, "City must only contain letters and spaces"),
  state: z.string()
    .min(1, "State is required")
    .regex(/^[A-Za-z\s]+$/, "State must only contain letters and spaces"),
  country: z.string()
    .min(1, "Country is required")
    .regex(/^[A-Za-z\s]+$/, "Country must only contain letters and spaces"),
  registerName: z.string()
    .min(1, "Register Name is required")
    .regex(/^[a-zA-Z\s]+$/, "Register Name must only contain alphabetic characters"),
  returnAddress: z.string().optional(),
  returnPhone: z.string().optional(),
  returnPincode: z.string().optional(),
  returnCity: z.string().optional(),
  returnState: z.string().optional(),
  returnCountry: z.string().optional(),
});

const ViewWarehouse = ({ isopen, onClose, warehouse }) => {
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const { isDarkMode, setLoading } = useMyContext();
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditId, isSetEditId] = useState(true);
  const [isEditEmail, isSetEditEmail] = useState(true);
  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm({
    resolver: zodResolver(schema),
  });

  useEffect(() => {
    if (warehouse) {
      reset({
        Id: warehouse.id || '',
        Name: warehouse.name || '',
        email: warehouse.email || '',
        phone: warehouse.phone || '',
        contact_person: warehouse.contact_person || '',
        date: warehouse.create_date || '',
        address: warehouse.address || '',
        pincode: warehouse.pincode || '',
        city: warehouse.city || '',
        state: warehouse.state || '',
        country: warehouse.country || '',
        registerName: warehouse.name || '',
        returnAddress: warehouse.return_address || '',
        returnPhone: warehouse.return_phone || '',
        returnPincode: warehouse.return_pincode || '',
        returnCity: warehouse.return_city || '',
        returnState: warehouse.return_state || '',
        returnCountry: warehouse.return_country || '',
      });
    }
  }, [warehouse, reset]);



  const onErrors = (errors) => {
    toast.error("Please fix the errors in the form.");
  };

  const onSubmit = async (data) => {
    const editWarehouseurl = Base_Url + editwarehouse
    try {
      const payload = {
        customer_id: cusid,
        id: warehouse.id,
        name: data.Name,
        email: data.email,
        phone: data.phone,
        contact_person: data.contact_person,
        address: data.address,
        pincode: data.pincode,
        city: data.city,
        state: data.state,
        country: data.country,
        return_address: data.returnAddress,
        return_phone: data.returnPhone,
        return_pincode: data.returnPincode,
        return_city: data.returnCity,
        return_state: data.returnState,
        return_country: data.returnCountry,
        create_date: data.date,
      };
      const response = await axios.post(editWarehouseurl, payload, {
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json',
        },
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        setIsEditMode(false);
        onClose();
      } else {
        toast.error(response.data.message || 'Failed to update warehouse');
      }
    } catch (error) {
         const errorMessagecontact_person = error.response?.data?.errors?.contact_person || "";
            const address = error.response?.data?.errors?.address || "";
            const email = error.response?.data?.errors?.email || "";
            const name = error.response?.data?.errors?.name || "";
            const return_country = error.response?.data?.errors?.return_country || "";
            const return_address = error.response?.data?.errors?.return_address || "";
            const return_pincode = error.response?.data?.errors?.return_address || "";
            const return_city = error.response?.data?.errors?.return_city || "";
            const return_state = error.response?.data?.errors?.return_city || "";
            const customer_id = error.response?.data?.errors?.customer_id || "";
            toast.error(errorMessagecontact_person || address || return_country || name || return_address || return_pincode || return_city || return_state || customer_id || email);
    }
  };

  const handleClose = () => {
    setIsEditMode(false);
    onClose();
  };

  const hanldeAllEditFileds = () => {
    setIsEditMode(!isEditMode);
    // isSetEditId(isEditId); 
    // isSetEditEmail(isEditEmail);
  }


  const fetchPincodeData = async (pincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${pincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });


      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];

        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
        setValue("city", city);
        setValue("state", state);
      }


      else if (data && data.message === "Unauthorized access - Invalid token") {
        // toast.error(data.message + " Please login Again");
      }

      else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      }


      else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };


  const fetchreturnPincodeData = async (returnPincode) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const urlgetPincode = `${Base_Url}${getpincode}?pincode=${returnPincode}`;
    try {
      const response = await fetch(urlgetPincode, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cus_id,
          'Content-Type': 'application/json'
        }
      });


      const data = await response.json();
      if (data && data.status === "SUCCESS") {
        let { city, state } = data.data[0];

        city = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();
        state = state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();

        setValue("returnCity", city);
        setValue("returnState", state);
      }
      else if (data && data.message === "Unauthorized access - Invalid token") {
        // toast.error(data.message + " Please login Again");
      }

      else if (data && data.status === "FAIL") {
        toast.error("Something Went Wrong Please Try Again With Another Pincode");
      }


      else {
        toast.error("Failed to fetch city and state data");
      }
    } catch (error) {
      console.error('Error fetching pincode data:', error);
      toast.error("Error fetching pincode data");
    }
  };


  const handleInputChange = (event) => {

    const { value, id } = event.target;
    if (['pincode', 'phone', 'return-pincode'].includes(id)) {
      const filteredValue = value.replace(/[^0-9]/g, '');
      event.target.value = filteredValue;
      // Trigger API call if input reaches 6 digits for `return-pincode`
      if (id === 'return-pincode' && filteredValue.length === 6) {
        fetchreturnPincodeData(filteredValue);
      }
      if (id === 'pincode' && filteredValue.length === 6) {
        fetchPincodeData(filteredValue);
      }
    }
    if (['facility-name', 'city', 'contact-person', 'state', 'returnState', 'returnCity', 'returnCountry', 'country'].includes(id)) {
      const filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
      event.target.value = filteredValue;

    }
  };

  // Shared styling tokens (visual only — does not touch form logic)
  const inputClass = "w-full px-3 py-2 rounded-lg border text-sm bg-white dark:bg-darkmodeColor dark:text-white border-slate-200 dark:border-gray-700 outline-none focus:ring-2 focus:ring-indigo-500/25 focus:border-indigo-500 disabled:bg-slate-50 dark:disabled:bg-gray-800/40 disabled:text-slate-500 dark:disabled:text-gray-400 disabled:cursor-not-allowed transition-colors";
  const labelClass = "block text-[10px] font-semibold text-slate-500 dark:text-gray-400 mb-1 uppercase tracking-wide";
  const errorClass = "text-rose-500 text-[11px] mt-1";
  const sectionWrapClass = "rounded-xl border border-slate-300 dark:border-gray-700 p-3 sm:p-3.5";

  return (
      <Dialog
        open={isopen}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          className: "rounded-2xl overflow-hidden"
        }}
      >
        <DialogTitle className="bg-gradient-to-r from-indigo-600 to-violet-600 text-white relative px-4 py-3">
          <div className="flex items-center gap-2.5">
            <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/15 flex-shrink-0">
              <FaWarehouse size={14} />
            </div>
            <div>
              <h2 className="text-sm font-bold text-white font-sans leading-tight">
                Warehouse Details
              </h2>
              <p className="text-[10px] text-indigo-100 leading-tight">
                {isEditMode ? 'Editing mode' : 'Viewing mode'}
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={handleClose}
            aria-label="Close"
            className="absolute top-2.5 right-2.5 flex items-center justify-center w-6 h-6 rounded-full bg-white/10 hover:bg-white/25 transition-colors"
          >
            <IoIosCloseCircle size={16} />
          </button>
        </DialogTitle>

        <DialogContent className="bg-white dark:bg-darkmodeColor dark:text-white custom-scrollbar p-0" style={{ maxHeight: '75vh' }}>
          <div className="p-1 sm:p-1 dark:bg-darkmodeColor dark:text-white">
            <form className="space-y-3" onSubmit={handleSubmit(onSubmit, onErrors)}>

              {/* Primary Information Section */}
              <div className={sectionWrapClass}>
                <h3 className="text-xs font-bold mb-2.5 text-slate-700 dark:text-white flex items-center gap-1.5">
                  <FaIdCard size={11} className="text-indigo-500" />
                  Primary Information
                </h3>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className={labelClass}>ID</label>
                    <input
                      type="text"
                      className={inputClass}
                      {...register('Id')}
                      disabled={isEditId}
                    />
                    {errors.Id && <p className={errorClass}>{errors.Id.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Name</label>
                    <input
                      type="text"
                      id="facility-name"
                      className={inputClass}
                      {...register('Name')}
                      disabled={!isEditMode}
                    />
                    {errors.Name && <p className={errorClass}>{errors.Name.message}</p>}
                  </div>
                </div>
              </div>

              {/* Contact Information Section */}
              <div className={sectionWrapClass}>
                <h3 className="text-xs font-bold mb-2.5 text-slate-700 dark:text-white flex items-center gap-1.5">
                  <FaAddressCard size={11} className="text-blue-500" />
                  Contact Information
                </h3>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className={labelClass}>Email</label>
                    <input
                      type="email"
                      className={inputClass}
                      {...register('email')}
                      disabled={isEditEmail}
                    />
                    {errors.email && <p className={errorClass}>{errors.email.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Contact Person</label>
                    <input
                      type="text"
                      className={inputClass}
                      {...register('contact_person')}
                      disabled={!isEditMode}
                    />
                    {errors.contact_person && <p className={errorClass}>{errors.contact_person.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Phone</label>
                    <input
                      type="tel"
                      id="phone"
                      className={inputClass}
                      {...register('phone')}
                      maxLength={10}
                      disabled={!isEditMode}
                    />
                    {errors.phone && <p className={errorClass}>{errors.phone.message}</p>}
                  </div>
                  <div>
                    <label className={labelClass}>Add Date</label>
                    <input
                      type="text"
                      className={inputClass}
                      {...register('date')}
                      disabled={!isEditMode}
                    />
                    {errors.date && <p className={errorClass}>{errors.date.message}</p>}
                  </div>
                </div>
              </div>

              {/* Address Information Section */}
              <div className={sectionWrapClass}>
                <h3 className="text-xs font-bold mb-2.5 text-slate-700 dark:text-white flex items-center gap-1.5">
                  <FaMapMarkerAlt size={11} className="text-emerald-500" />
                  Address Information
                </h3>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className={labelClass}>Address</label>
                    <input
                      type="text"
                      id="address"
                      className={inputClass}
                      {...register('address')}
                      disabled={!isEditMode}
                    />
                    {errors.address && <p className={errorClass}>{errors.address.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Pincode</label>
                    <input
                      type="text"
                      id="pincode"
                      className={inputClass}
                      {...register('pincode')}
                      onChange={handleInputChange}
                      maxLength={6}
                      disabled={!isEditMode}
                    />
                    {errors.pincode && <p className={errorClass}>{errors.pincode.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>City</label>
                    <input
                      type="text"
                      id="city"
                      className={inputClass}
                      {...register('city')}
                      disabled={!isEditMode}
                    />
                    {errors.city && <p className={errorClass}>{errors.city.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>State</label>
                    <input
                      type="text"
                      id="state"
                      className={inputClass}
                      {...register('state')}
                      disabled={!isEditMode}
                    />
                    {errors.state && <p className={errorClass}>{errors.state.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Country</label>
                    <input
                      type="text"
                      id='country'
                      className={inputClass}
                      {...register('country')}
                      disabled={!isEditMode}
                    />
                    {errors.country && <p className={errorClass}>{errors.country.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Register Name</label>
                    <input
                      type="text"
                      className={inputClass}
                      {...register('registerName')}
                      disabled={!isEditMode}
                    />
                    {errors.registerName && <p className={errorClass}>{errors.registerName.message}</p>}
                  </div>
                </div>
              </div>

              {/* Return Address Section */}
              <div className={sectionWrapClass}>
                <h3 className="text-xs font-bold mb-2.5 text-slate-700 dark:text-white flex items-center gap-1.5">
                  <FaUndo size={11} className="text-amber-500" />
                  Return Address Details
                </h3>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className={labelClass}>Return Address</label>
                    <input
                      type="text"
                      id="returnAddress"
                      className={inputClass}
                      {...register('returnAddress')}
                      disabled={!isEditMode}
                    />
                    {errors.returnAddress && <p className={errorClass}>{errors.returnAddress.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Return Pincode</label>
                    <input
                      type="text"
                      id='return-pincode'
                      className={inputClass}
                      {...register('returnPincode')}
                      onChange={handleInputChange}
                      maxLength={6}
                      disabled={!isEditMode}
                    />
                    {errors.returnPincode && <p className={errorClass}>{errors.returnPincode.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Return City</label>
                    <input
                      type="text"
                      id="returnCity"
                      className={inputClass}
                      {...register('returnCity')}
                      disabled={!isEditMode}
                    />
                    {errors.returnCity && <p className={errorClass}>{errors.returnCity.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Return State</label>
                    <input
                      type="text"
                      id="returnState"
                      className={inputClass}
                      {...register('returnState')}
                      disabled={!isEditMode}
                    />
                    {errors.returnState && <p className={errorClass}>{errors.returnState.message}</p>}
                  </div>

                  <div>
                    <label className={labelClass}>Return Country</label>
                    <input
                      type="text"
                      className={inputClass}
                      {...register('returnCountry')}
                      disabled={!isEditMode}
                    />
                    {errors.returnCountry && <p className={errorClass}>{errors.returnCountry.message}</p>}
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-wrap gap-2 pt-1 sticky bottom-0 bg-white dark:bg-darkmodeColor">
                <button
                  type="button"
                  onClick={hanldeAllEditFileds}
                  className="inline-flex items-center gap-1.5 py-2 px-4 rounded-lg font-semibold text-xs transition-colors bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-white/10 dark:text-white dark:hover:bg-white/15"
                >
                  {isEditMode ? (
                    <>
                      <FaTimes size={11} /> Cancel Editing
                    </>
                  ) : (
                    <>
                      <FaEdit size={11} /> Edit Warehouse
                    </>
                  )}
                </button>

                {(isEditMode && isEditId && isEditEmail) && (
                  <button
                    type="submit"
                    className="inline-flex items-center gap-1.5 py-2 px-4 rounded-lg font-semibold text-xs text-white bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 shadow-sm shadow-emerald-500/25 transition-colors"
                  >
                    <FaSave size={11} /> Save Changes
                  </button>
                )}
              </div>
            </form>
          </div>
        </DialogContent>
      </Dialog>
  );
};

export default ViewWarehouse;